import { render, staticRenderFns } from "./order_confirm.vue?vue&type=template&id=f0840832&scoped=true"
import script from "./order_confirm.vue?vue&type=script&lang=js"
export * from "./order_confirm.vue?vue&type=script&lang=js"
import style0 from "./order_confirm.vue?vue&type=style&index=0&id=f0840832&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0840832",
  null
  
)

export default component.exports